(function () {

  if (document.location.pathname === '/pages/influencers') {

    var multicolumnButton = document.querySelector('.multicolumn .button');

    if (typeof multicolumnButton !== 'undefined' && multicolumnButton !== null) {

      multicolumnButton.removeAttribute('aria-disabled');

      multicolumnButton.addEventListener('click', function () {

        document.querySelector('.contact-form-modal').classList.add('-modal-open');
        document.querySelector('.contact-form-modal').classList.remove('-modal-close');
      });

      var modalCloseButton = document.querySelector('.contact-form-modal .contact-form-modal__close-icon');

      modalCloseButton.addEventListener('click', function () {

        document.querySelector('.contact-form-modal').classList.add('-modal-close');
        document.querySelector('.contact-form-modal').classList.remove('-modal-open');
        document.getElementById('ContactForm').reset();
      });
    }
  }
})();

(function() {
  // Check if the observer variable is not defined
  if (typeof observer === 'undefined') {
    // Selector path for the target element
    var targetSelector = 'product-form.product-form form.form .product-form__add-to-cart span#product_form_add_to_cart_label';

    // Check if the element with the specified selector path exists
    if ($(targetSelector).length) {
      // Select the target node using jQuery
      var target = $(targetSelector)[0];

      // Create a MutationObserver instance
      var observer;

      // Function to handle mutations
      function handleMutations(mutations) {
        mutations.forEach(function(mutation) {
          // Check if the text content has changed
          if (mutation.type === 'childList' && mutation.target.textContent !== mutation.oldValue) {
            var text = $(targetSelector).text();
          }
        });
      }

      // Configuration of the observer
      var config = { childList: true, subtree: true };

      // Start observing the target node for configured mutations
      observer = new MutationObserver(handleMutations);
      observer.observe(target, config);
    }
    // else {
    //   console.error("Element with selector '" + targetSelector + "' not found.");
    // }
  }
})();

// $('.product-sticky-add-to-cart-mobile button.product-form__submit,.farm-shirt-btn.btn-add-to-cart').click(function(){
//     var text = $(this).find('span#sticky_mobile_product_form_add_to_cart_label').text();
//     var text_btn = $(this).find('.add-to-cart-text').text();
//     if(text == 'Add to Cart'){
//         $('product-form.product-form form.form .product-form__submit').click();
//     }
//     if(text_btn == 'Add to Cart'){
//        $('product-form.product-form form.form .product-form__submit').click();
//     }
// });


$('.product-sticky-add-to-cart-mobile button.product-form__submit, .farm-shirt-btn.btn-add-to-cart, #sticky_addtocart_submit_button').click(function () {

    // Mobile Sticky Label
    var mobileText = $(this).find('#sticky_mobile_product_form_add_to_cart_label').text().trim();
    var desktopText = $(this).find('#sticky_desktop_product_form_add_to_cart_label').text().trim();
    var text_btn = $(this).find('.add-to-cart-text').text().trim();
    if (
        mobileText === 'Add to Cart' ||
        desktopText === 'Add to Cart' ||
        text_btn === 'Add to Cart'
    ) {

       if ($(window).width() < 768) {
          $('.mobile-product-main .product-form__submit').click();
       }else{
        $('.desktop-container .product__info-wrapper .product-form__submit').click();
       }
    }
});

$('.farm-shirt-btn.btn-add-to-cart').click(function(){
    event.preventDefault();
  var productInfoContainer = document.querySelector('.mobile-product-main product-info');

    if (productInfoContainer) {
      productInfoContainer.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start"
      });
    }
  });